var AccessDeviceTypes;
(function (AccessDeviceTypes) {
    AccessDeviceTypes["CONCIERGE"] = "Concierge";
    AccessDeviceTypes["VENDOR"] = "Vendor";
    AccessDeviceTypes["KEYBOX"] = "Keybox";
    AccessDeviceTypes["PINPAD"] = "Pinpad";
})(AccessDeviceTypes || (AccessDeviceTypes = {}));

export { AccessDeviceTypes };
